<template lang="html">
  <div class="page-container">

    <md-app class="viewport">
      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar/>
      </md-app-toolbar>

      <md-app-content class="all-search">

        <div class="filterResults">

          <md-card class="CardfilterResults">
            <md-card-content>
              <searchFilter @typeChange="loadType" />
            </md-card-content>
          </md-card>

        </div>

        <div class="divResultSearch">

          <div class="divSearch">
            <input class="inputSearch" id="search" type="search" v-model="searchQuery" placeholder="Pesquisar">

            <md-button :to="{ name: 'search', query: { s: searchQuery } }" class="buttonSearch" :md-ripple="false">
              <md-icon style="color: #fff;">search</md-icon>
            </md-button>

            <md-button class="md-primary buttonFilter" :md-ripple="false" @click="showDialog = true">Filtro</md-button>
          </div>

          <md-dialog :md-active.sync="showDialog">
            <md-dialog-content>
              <searchFilter @typeChange="loadType" />
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-primary md-raised" @click="showDialog = false">
                Aplicar
              </md-button>
            </md-dialog-actions>
          </md-dialog>

          <div v-if="searchQuery && type">
            <!-- <h3 style="margin-left: 5vw;">Resultado:</h3> -->
            <card-list
              v-if="type == 'chapter'"
              typeTxt="capítulo"
              :items="chapters"
              :pageSize="options.pagination.pageSize"
              :hasMore="hasMore.chapter"
              @loadPage="loadMoreChapters"
            >
              <medium slot-scope="{ item }"
                class="profile-card"
                :chapter="item"
              />
            </card-list>
            <card-list
              v-else-if="type == 'profile'"
              typeTxt="perfil"
              :items="profiles"
              :pageSize="options.pagination.pageSize"
              :hasMore="hasMore.profile"
              @loadPage="loadMoreProfiles"
            >
              <card-profile slot-scope="{ item }"
                class="profile-card"
                :profile="item"
              />
            </card-list>
            <div v-else-if="type == 'place'">
              <!-- <minimap-markers v-if="places" style="height: 200px;" mode="fixed" :place="places" /> -->
              <card-list
                typeTxt="lugar"
                :items="places"
                :pageSize="options.pagination.pageSize"
                :hasMore="hasMore.place"
                @loadPage="loadMorePlaces"
              >
                <card-place slot-scope="{ item }"
                  class="profile-card"
                  :place="item"
                />
              </card-list>
            </div>

          </div>
          <md-card v-else-if="!searchQuery" class="result-chapters" style="margin-top: 15px;">
            <md-card-header>
              Digite algo para procurar um capítulo ou perfil
            </md-card-header>
          </md-card>
          <md-card v-else-if="!type" class="result-chapters" style="margin-top: 15px;">
            <md-card-header>
              Selecione o filtro da busca
            </md-card-header>
          </md-card>

        </div>

      </md-app-content>

    </md-app>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import navbar from "../toolbar/navbar";
  import searchFilter from "../content/search/searchFilter";
  import medium from "@/components/shared/chapter/medium";
  import cardProfile from "../content/search/cardProfile";
  import cardPlace from "../content/search/cardPlace";
  import cardList from "../content/search/cardList";
  import bus from "@/api/bus";
  // import minimapMarkers from "@/components/drawer/maps/minimapMarkers";

  export default {
    data() {
      return {
        searchQuery: this.$route.query.s || "",
        type: "",
        pageSize: 10,
        hasMore: {
          chapter: true,
          profile: true,
          place: true
        },
        options: {
          pagination: {
            page: 0,
            pageSize: 10
          }
        },
        showDialog: false,
        error: null
      }
    },
    components: {
      navbar,
      cardProfile,
      medium,
      cardPlace,
      cardList,
      searchFilter,
      // minimapMarkers
    },
    computed: {
      ...mapGetters("Search", {
        chapters: "getChapters",
        profiles: "getProfiles",
        places: "getPlaces"
      }),
    },
    watch: {
      "$route.query.s"(query) {
        this.searchQuery = query;
        this.resetSearch();
      }
    },
    mounted() {
      if (this.type == "chapter")
        this.searchChapters({ query: this.searchQuery, options: this.options });
      else if (this.type == "profile")
        this.searchProfiles({ query: this.searchQuery, options: this.options });
      else if (this.type == "place")
        this.searchPlaces({ query: this.searchQuery, options: this.options });
    },
    methods: {
      ...mapActions("Search", [
        "searchChapters",
        "searchProfiles",
        "searchPlaces",
        "clearSearch"
      ]),
      loadType(type) {
        this.type = type;
        if (type == "chapter")
          if (!this.chapters)
            this.searchChapters({ query: this.searchQuery, options: this.options });
        if (type == "profile")
          if (!this.profiles)
            this.searchProfiles({ query: this.searchQuery, options: this.options });
        if (type == "place")
          if (!this.places)
            this.searchPlaces({ query: this.searchQuery, options: this.options });
      },
      loadMoreChapters(options) {
        this.searchChapters({ query: this.searchQuery, options })
        .then(chapters => this.hasMore.chapter = !(chapters.length < this.options.pagination.pageSize));
      },
      loadMoreProfiles(options) {
        this.searchProfiles({ query: this.searchQuery, options })
        .then(profiles => this.hasMore.profile = !(profiles.length < this.options.pagination.pageSize));
      },
      loadMorePlaces(options) {
        this.searchPlaces({ query: this.searchQuery, options })
        .then(places => this.hasMore.place = !(places.length < this.options.pagination.pageSize));
      },
      resetSearch() {
        bus.emit.clearSearch();
        this.hasMore.chapter = true;
        this.hasMore.profile = true;
        this.hasMore.place = true;
        this.clearSearch();
        this.loadType(this.type);
      }
    },
    metaInfo() {
      return {
        title: this.searchQuery || "Pesquisa",
        meta: [
          {name: "robots", content: "index"},
          {name: "keywords", content: `pesquisar, ${this.searchQuery}`},
          {name: "description", content: "Página de busca da rede social Chapstory."},
          {rel: "canonical", href: `https://www.chapstory.com/search?s=${this.searchQuery}`}
        ]
      }
    }
  };
</script>

<style scoped>
.viewport {
  height: 100vh;
  width: 100vw;
}

/* .md-card{
  margin: 16px;
} */

.md-content{
background-color: #e4f9f54a;
}

/* .sidebar-search {
  max-width: 450px;
  width: 45vw;
  height: 100%;
  min-width: 300px;
  overflow-y: auto;
} */

.all-search {
  padding: 0;
  height: calc(100vh - 50px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* #navbar-search {
  position: fixed;
  width: 100%;
  height: 5%;
  background-color: blue;
  width: calc(100% - 468px);
  z-index: 0;
  padding-right: 16px;
} */

.md-toolbar,
.md-toolbar-row,
.md-app-toolbar,
.md-app-toolbar-row {
  width: 100%;
  min-height: 50px !important;
  display: flex;
  align-items: center;
  align-content: center;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: opacity, background-color, box-shadow, transform, color,
    min-height;
  will-change: opacity, background-color, box-shadow, transform, color,
    min-height;
}

/* .md-app-container .md-app-scroller {
  overflow-y: auto;
} */

.filterResults{
  position: fixed;
  float: left;
  left: 80px;
  width: 25%;
}

.CardfilterResults{
  height: 100vh;
  overflow-y: auto
}

.radioFilterSerach{
  margin: 20px;
}

.md-radio{
  display: flex;
}

.dividerSearch{
  margin: 15px;
}

.divResultSearch{
  /* display: flex;
  flex-flow: column; */
  position: relative;
  float: right;
  margin-right: 20px;
  width: 60%;
  /* margin: 0 auto; */
  /* width: 85%; */
  /* max-width: 600px; */
}

.divSearch{
  display: none;
}

.result-profile {
  position: relative;
  /* float: right; */
  top: 0;
  /* left: 160px; */
  padding: 16px;
  /* width: 50%; */
}

.result-chapters {
  position: relative;
  /* float: right; */
  top: 0;
  /* left: 160px; */
  /* width: 50%; */
  height: 50%;
}

.linksSearch{
  margin: 0 20px;
}

.links{
  margin-right: 5px;
  font-size: small;
}

.profile-card {
  margin: 12px auto;
  width: 100%;
}

@media (max-width: 850px) {

  .filterResults{
    left: 10px;
    width: 35%;
  }

}

@media (max-width: 510px) {

  .filterResults{
    display: none;
  }

  .divResultSearch{
    margin: 0;
    width: 100%;
  }

  .inputSearch{
    height: 7vh;
    width: 100%;
  }

  .buttonSearch{
    width: 100%;
    margin: auto 0;
    background-color: #40514e;
  }

  .divSearch{
    display: contents;
    float: right;
  }

}
</style>
